class TransportScheduleStatus {
  static EARLY = 'early';

  static ON_TIME = 'onTime';

  static LATE = 'late';
}

export default TransportScheduleStatus;
